"use client";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

import { GetResourceResponseDto } from "@onair/repositories";
import FolderSvg from "@onair/ui/svg/folder";

import ResourceItem, { ResourceItemProps } from "./resource-item";
import SubLibraryItem from "./sub-library-item";

export interface DocumentItemListProps {
	isLoading: boolean;
	libraries: any[];
	resources: (GetResourceResponseDto & { isNew: boolean })[];
	selectedResourceId: string | null;
	currentResourceId: string | null;
	setCurrentResourceId: React.Dispatch<React.SetStateAction<string | null>>;
	onSelectLibrary: (id: string, name: string) => void;
	onEditSubLibrary: (id: string, name: string) => void;
	onDeleteLibrary: (id: string) => Promise<any>;
	onDeleteResource: (id: string) => void;
	isMultiple: boolean;
	multipleResources: string[];
	setMultipleResources: any;
	setSelectResourceId: (id: string) => void;
	refetchLibraryAndResource: () => Promise<any>;
	onSelectResource?: ResourceItemProps["onSelectResource"];
}

const DocumentItemList = ({
	isLoading,
	libraries,
	resources,
	selectedResourceId,
	currentResourceId,
	setCurrentResourceId,
	onSelectLibrary,
	onEditSubLibrary,
	onDeleteLibrary,
	onDeleteResource,
	isMultiple,
	multipleResources,
	setMultipleResources,
	setSelectResourceId,
	refetchLibraryAndResource,
	onSelectResource,
}: DocumentItemListProps) => {
	if (isLoading) {
		return (
			<Grid item xs={24}>
				<Box display="flex" justifyContent="center" alignItems="center">
					<CircularProgress />
				</Box>
			</Grid>
		);
	}

	if (!libraries.length && !resources.length) {
		return (
			<Grid item xs={24}>
				<Stack className="flex flex-col items-center justify-center mt-10">
					<FolderSvg />
					<Typography color="text.primary" variant="body2" align="center">
						Tạo thư mục để lưu trữ và quản lý
					</Typography>
				</Stack>
			</Grid>
		);
	}

	return (
		<>
			{libraries.map((library) => (
				<SubLibraryItem
					key={library.id}
					library={library}
					handleEditSubLibrary={onEditSubLibrary}
					onSelectLibrary={onSelectLibrary}
					onDelete={onDeleteLibrary}
					refetch={refetchLibraryAndResource}
				/>
			))}
			{resources.map((resource) => (
				<ResourceItem
					key={resource.id}
					handleSelectResourceId={setSelectResourceId}
					resource={resource}
					selectResourceId={selectedResourceId}
					currentResourceId={currentResourceId}
					setCurrentResourceId={setCurrentResourceId}
					onSelectResource={onSelectResource}
					onDelete={onDeleteResource}
					isMultiple={isMultiple}
					multipleResources={multipleResources}
					setMultipleResources={setMultipleResources}
					refetch={refetchLibraryAndResource}
				/>
			))}
		</>
	);
};

export default DocumentItemList;
